__turbopack_context__.v({
  "avatar": "ProfileMenu-module-scss-module__sETA8q__avatar",
  "avatarPlaceholder": "ProfileMenu-module-scss-module__sETA8q__avatarPlaceholder",
  "caretIcon": "ProfileMenu-module-scss-module__sETA8q__caretIcon",
  "menuBadge": "ProfileMenu-module-scss-module__sETA8q__menuBadge",
  "menuButton": "ProfileMenu-module-scss-module__sETA8q__menuButton",
  "menuDropdown": "ProfileMenu-module-scss-module__sETA8q__menuDropdown",
  "menuIcon": "ProfileMenu-module-scss-module__sETA8q__menuIcon",
  "menuItem": "ProfileMenu-module-scss-module__sETA8q__menuItem",
  "menuLabel": "ProfileMenu-module-scss-module__sETA8q__menuLabel",
  "menuList": "ProfileMenu-module-scss-module__sETA8q__menuList",
  "open": "ProfileMenu-module-scss-module__sETA8q__open",
  "profileButton": "ProfileMenu-module-scss-module__sETA8q__profileButton",
  "profileMenu": "ProfileMenu-module-scss-module__sETA8q__profileMenu",
  "userDetails": "ProfileMenu-module-scss-module__sETA8q__userDetails",
  "userEmail": "ProfileMenu-module-scss-module__sETA8q__userEmail",
  "userInfo": "ProfileMenu-module-scss-module__sETA8q__userInfo",
  "userName": "ProfileMenu-module-scss-module__sETA8q__userName",
});
